import modules_form from './form/index.js'
import _actions_search from './_actions/search.js'
import _actions_get from './_actions/get.js'
import _actions_create from './_actions/create.js'
import _actions_clean from './_actions/clean.js'
import _mutations_set from './_mutations/set.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        set: _mutations_set,
    },
    actions:{
        clean: _actions_clean,
        create: _actions_create,
        get: _actions_get,
        search: _actions_search,
    },
    modules:{
        form: modules_form,
    },
}